<template>
  <IonToolbar color="white" class="border-b-2 border-gray-300">
    <div class="text-2xl font-bold text-gray-900">Dashboard</div>
  </IonToolbar>
</template>

<script setup lang="ts">
import { IonToolbar } from '@ionic/vue';
</script>

<style scoped></style>
